var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Javascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 31.937,
    y1: 5,
    x2: 31.937,
    y2: 58.875,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 41.5,
    y1: 10,
    x2: 41.5,
    y2: 54,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 23.313,
    y1: 16,
    x2: 23.313,
    y2: 46.625,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18d26e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18d26e"
  })))), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    fill: "#dddddd",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.875,58.875c-0.092,0 -0.183,-0.013 -0.271,-0.037l-18.625,-5.25c-0.398,-0.113 -0.687,-0.46 -0.725,-0.872l-4.25,-46.625c-0.025,-0.28 0.068,-0.558 0.258,-0.765c0.189,-0.208 0.457,-0.326 0.738,-0.326h45.875c0.28,0 0.547,0.117 0.736,0.324c0.189,0.206 0.284,0.482 0.26,0.762l-4,46.625c-0.035,0.416 -0.327,0.767 -0.729,0.878l-19,5.25c-0.088,0.024 -0.177,0.036 -0.267,0.036zM14.184,51.85l17.694,4.987l18.061,-4.99l3.846,-44.847h-43.689z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,10v44l15.25,-4l3.75,-40zM47.375,28.625l-1.125,14.75l-12.5,3.125v-5.25l9,-2.5l0.125,-4.375l-9.25,1.375v-19.75h14.625l-0.375,5.375l-9.625,0.125v8.125z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625,42.875v-5.5l9,2.5v-23.875h4.375v30.625z",
    fill: "url(#color-3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Javascript);
export default __webpack_public_path__ + "static/media/icons8-javascript.1ffe6818af2919222c3dffbad06ce0b0.svg";
export { ForwardRef as ReactComponent };